import { render, staticRenderFns } from "./ExaminationSpeciesItem.vue?vue&type=template&id=2f86f07c&scoped=true&"
import script from "./ExaminationSpeciesItem.vue?vue&type=script&lang=js&"
export * from "./ExaminationSpeciesItem.vue?vue&type=script&lang=js&"
import style0 from "./ExaminationSpeciesItem.vue?vue&type=style&index=0&id=2f86f07c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f86f07c",
  null
  
)

export default component.exports